<template>
  <aside class="vuestic-sidebar">
    <vuestic-scrollbar>
      <ul class="sidebar-menu">
        <slot name="menu"></slot>
      </ul>
    </vuestic-scrollbar>
    <div class="rest"></div>
  </aside>

</template>

<script>
export default {
  name: 'vuestic-sidebar',
  props: {
    hidden: {
      type: Boolean,
      required: true,
    },
  },
}
</script>

<style lang="scss">
.vuestic-sidebar {
  $side-bar-h: 100%;
  @include media-breakpoint-down(md) {
    top: $sidebar-mobile-top;
    left: $sidebar-mobile-left;
    width: $sidebar-mobile-width;
    z-index: $sidebar-mobile-z-index;
  }

  height: $sidebar-viewport-height;
  position: absolute;
  left: 0;
  right: 0;
  width: $sidebar-width;
  transition: all 0.3s ease-in-out;
  opacity: 1;

  .vuestic-scrollbar {
    max-height: 100%;
    width: 120%;

    .sidebar-menu {
      height: 100%;
      margin-bottom: 0;
      list-style: none;
      padding-left: 0;
      li {
        display: block;
        padding-left: 0;
      }
    }

    .scrollbar-wrapper {
      box-shadow: 0 0 0 0;
    }

    .scrollbar-content {
      background: $sidebar-bg;
      /*height: 100%;*/
    }

  }
  .rest{
    background: $sidebar-bg;
    height: 100%;
    width: 120%;
  }

  &.sidebar-hidden {
    @include media-breakpoint-down(md) {
      top: $sidebar-hidden-top-mobile;
      opacity: 0;
      /*<!--z-index: $sidebar-mobile-z-index;-->*/
      height: $sidebar-hidden-height-mobile;
    }
    top: $sidebar-hidden-top;
    opacity: 0;
    z-index: $min-z-index;
  }
  &.sidebar-hidden + .content-wrap {
    @include media-breakpoint-down(md) {
      margin-left: 0;
    }
    margin-left: $sidebar-left;
  }
}
</style>
